import config from '@/config/prod.env';
import header from '@/helper/header';
import common from '@/helper/common';

const mainUrl = `${process.env.VUE_APP_API_URL}/Report`;

export default {    
    getAllPaging: async (params) => {
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "currentPage": params.currentPage,
                "perPage": (params.perPage)? params.perPage : config.DEFAULT_LIMIT,
                "sortBy": (params.sortBy)? params.sortBy: "0",
                "orderDesc": params.sortDesc,
                "searchkey": (params.searchKey)? params.searchKey: ""
            })
        };
    
        let rs = await fetch(`${mainUrl}/GetAllPaging`, requestOptions);
        return await common.handleResponse(rs);
    },

    getByWorkspaceIdPaging: async (params, workspaceId) => {
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "currentPage": params.currentPage,
                "perPage": (params.perPage)? params.perPage : config.DEFAULT_LIMIT,
                "sortBy": (params.sortBy)? params.sortBy: "0",
                "orderDesc": params.sortDesc,
                "searchkey": (params.searchKey)? params.searchKey: ""
            })
        };
    
        let rs = await fetch(`${mainUrl}/GetByWorkspaceIdPaging?workspaceId=${workspaceId}`, requestOptions);
        return await common.handleResponse(rs);
    },

    getById: async (id) => {
        const requestOptions = {
            method: 'GET',
            headers: await header.authHeaderNoToken(),
        };
    
        let rs = await fetch(`${mainUrl}/GetById?id=${id}`, requestOptions);
        return await common.handleResponse(rs);
    },

    getByWorkspaceId: async (workspaceId, status) => {
        const requestOptions = {
            method: 'GET',
            headers: await header.authHeaderWithToken(),
        };
    
        let rs = await fetch(`${mainUrl}/GetByWorkspaceId?workspaceId=${workspaceId}&status=${status}`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    create: async (report) => {
        let powerBIReport = JSON.parse(report.pbiReportInfoStr || "{}");
        var requestOptions = {
            method: 'POST',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify({
                "reportName": report.reportName,
                "imageUrl": report.imageUrl || "",
                "workspaceId": report.workspaceId,
                "isWebUrl": report.isWebUrl,
                "webUrl": report.webUrl,
                "pbiReportId": powerBIReport.id,
                "pbiReportName": powerBIReport.name,
                "pbiReportType": powerBIReport.reportType,
                "pbiWebUrl": powerBIReport.webUrl,
                "pbiEmbedUrl": powerBIReport.embedUrl,
                "pbiIsFromPbix": powerBIReport.isFromPbix,
                "pbiIsOwnedByMe": powerBIReport.isOwnedByMe,
                "pbiDatasetId": powerBIReport.datasetId,
                "pbiDatasetWorkspaceId": powerBIReport.datasetWorkspaceId,
            }),
        };
    
        let rs = await fetch(`${mainUrl}/Create`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    update: async (report) => {
        let powerBIReport = JSON.parse(report.pbiReportInfoStr || "{}");
        const requestOptions = {
            method: 'PUT',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify({
                "id": report.id,
                "reportName": report.reportName,
                "imageUrl": report.imageUrl || "",
                "workspaceId": report.workspaceId,
                "isWebUrl": report.isWebUrl,
                "webUrl": report.webUrl,
                "pbiReportId": powerBIReport.id,
                "pbiReportName": powerBIReport.name,
                "pbiReportType": powerBIReport.reportType,
                "pbiWebUrl": powerBIReport.webUrl,
                "pbiEmbedUrl": powerBIReport.embedUrl,
                "pbiIsFromPbix": powerBIReport.isFromPbix,
                "pbiIsOwnedByMe": powerBIReport.isOwnedByMe,
                "pbiDatasetId": powerBIReport.datasetId,
                "pbiDatasetWorkspaceId": powerBIReport.datasetWorkspaceId,
            })
        };
    
        let rs = await fetch(`${mainUrl}/Update`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    updateStatus: async (id, status) => {
        const requestOptions = {
            method: 'PUT',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify({
                id: id,
                status: status
            })
        };
    
        let rs = await fetch(`${mainUrl}/UpdateStatus`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    delete: async (id) => {
        const requestOptions = {
            method: 'DELETE',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify({ id })
        };
    
        let rs = await fetch(`${mainUrl}/Delete`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    deleteMany: async (ids) => {
        const requestOptions = {
            method: 'DELETE',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify(ids)
        };
    
        let rs = await fetch(`${mainUrl}/DeleteMany`, requestOptions);
        return await common.handleResponse(rs);
    },
}